import axios from 'axios'
const { STD_API_URL } = process.env

const studentRequest = axios.create({
  baseURL: STD_API_URL || 'https://example.com/', // API server url
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  maxContentLength: 100 * 1024 * 1024,
  maxBodyLength: 100 * 1024 * 1024,
  // Increase timeout for large uploads
  timeout: 180000 // 3 minutes
})

// OTP invite flow: when the candidate enters via /assessment/start/... (or the
// legacy /ai-interview/start/...) they get a scoped JWT in sessionStorage but
// no portal login. In an active invite session the scoped token IS this
// browser's identity, so it must take precedence over any portal default
// Authorization header — otherwise a stale/expired portal token set by
// initializeApp() shadows the fresh 12h scoped token and the assessment calls
// fail with "jwt expired" even though a valid scoped token exists.
// Precedence: explicit per-request header > scoped invite token > portal default.
// A normal portal student never has the scoped key set (it's written only on OTP
// verify and cleared on completion), so this is a no-op for them.
// Read the new generic key first, then the legacy AI-interview key. (Inlined
// rather than imported to avoid any module-cycle risk in the axios util.)
studentRequest.interceptors.request.use((config) => {
  try {
    const perRequestAuth =
      config.headers && (config.headers.Authorization || config.headers.authorization)
    if (!perRequestAuth && typeof sessionStorage !== 'undefined') {
      const scoped =
        sessionStorage.getItem('assessment_invite_scoped_jwt') ||
        sessionStorage.getItem('ai_interview_scoped_jwt')
      if (scoped) {
        config.headers = config.headers || {}
        config.headers.Authorization = scoped
      }
    }
  } catch (_) { /* no-op */ }
  return config
})

export default studentRequest
